import PropTypes from "prop-types";
import React from "react";

function MessageDisplay({ type, message, onAction }) {
  // Define styles for different types
  const styles = {
    error: {
      container: "border-[#D43A3A] bg-[#FFEAEA] text-[#D43A3A]",
      button: "bg-[#D43A3A] hover:bg-[#C32F2F]",
    },
    warning: {
      container: "border-[#FFAA00] bg-[#FFF4E5] text-[#FFAA00]",
      button: "bg-[#FFAA00] hover:bg-[#E59C00]",
    },
    info: {
      container: "border-[#2C7BE5] bg-[#E5F0FF] text-[#2C7BE5]",
      button: "bg-[#2C7BE5] hover:bg-[#2469C9]",
    },
  };

  const defaultMessage = {
    error: "Something went wrong. Please try again.",
    warning: "There might be an issue. Please proceed with caution.",
    info: "Here is some information for your reference.",
  };

  const selectedStyle = styles[type] || styles.info;

  return (
    <div
      className={`mx-[40px] my-4 rounded-lg border p-4 text-left font-outfit text-[16px] font-medium leading-[20.16px] ${selectedStyle.container}`}
    >
      <p className="mb-2">{message || defaultMessage[type]}</p>
      {onAction && (
        <button
          onClick={onAction}
          className={`mt-2 rounded-lg px-4 py-2 text-white focus:outline-none ${selectedStyle.button}`}
        >
          {type === "error" ? "Retry" : "Ok"}
        </button>
      )}
    </div>
  );
}

MessageDisplay.propTypes = {
  type: PropTypes.oneOf(["error", "warning", "info"]).isRequired,
  message: PropTypes.string,
  onAction: PropTypes.func,
};

MessageDisplay.defaultProps = {
  message: "",
  onAction: null,
};

export default MessageDisplay;
